import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { userServices } from '../../services/userServices';

// Create an async thunk to fetch user details
export const fetchUserDetails = createAsyncThunk(
  'userDetails/fetchUserDetails',
  async (userEmail, { rejectWithValue, getState }) => {
    const state = getState();
    // Check if the user data is already loaded and not empty
    if (state.userDetails.data && state.userDetails.data.length !== 0) {
      return state.userDetails.data; 
    }

    try {
      const response = await userServices.getUserDetails(userEmail);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const userDetailsSlice = createSlice({
  name: 'userDetails',
  initialState: {
    data: [],   
    loading: false,
    error: null,
  },
  reducers: {logout: (state) => {
    state.data = []; // Clear the user data
    state.loading = false; // Reset loading state
    state.error = null; // Reset error state
  },},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetails.pending, (state) => {
        state.loading = true; 
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // Store the fetched user data
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.payload; // Store the error message
      });
  },
});
export const { logout } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
